export function getCurrentUser() {
  return window.CURRENT_USER;
}

export function setCurrentUser(user: User) {
  window.CURRENT_USER = user;
}
